<!--AFFICHAGE BLOC RIQUES -->
<template>
  <v-container v-if="this.condition()" fluid>
    <a v-if="detail!=null"  class="anchor" id="blocrisque"></a>
    <v-row dense>
      <v-col cols="12">
        <v-card elevation="2">

          <v-card-title  v-if="detail!=null">
            <v-icon dense left color="orange">mdi-map-marker-alert</v-icon>
            Risques naturels et technologiques
          </v-card-title>
          <v-card-text v-if="detail!=null">
            <v-data-table
                dense
                :headers="headers_tests"
                :items="items_tests"
                item-class="red"
                item-key="id"
                class="elevation-1"
                :sort-by="['valeur']"
                :sort-desc="[true]"
            >
              <template #item="{ item }">
                <tr :class="item.class">
                  <td><v-icon>{{ item.icon }}</v-icon></td>
                  <td>{{item.libelle}}</td>
                  <td>{{item.valeur}}</td>
                  <td>{{item.valeur_libelle}}</td>
                  <td>{{item.detail}}</td>
                  <td style="padding: 5px 0px">{{item.detail_libelle}}</td>
                  <td>{{item.geo_type}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>



          <v-card-title  v-if="detail==null">
            <v-icon dense left color="orange" v-if="detail!=null">mdi-map-marker-alert</v-icon>
            Risques naturels et technologiques
          </v-card-title>
          <v-card-text v-if="detail==null">
          <template v-for="risque in georisk">
            <PictoItem v-bind:data="risque" :key="risque.key" />
          </template>
            <PictoItem v-if="this.seismes!=null" v-bind:data="seismes"/>
            <PictoItem v-if="this.radon!=null" v-bind:data="radon"/>
            <PictoItem v-if="this.catnat!=null&&this.detail==null" v-bind:data="catnat"/>
            <PictoItem v-if="this.risques!=null&&this.detail==null" v-bind:data="risques"/>
            <PictoItem v-if="this.icpe_etablissements_risque!=null&&this.detail==null"
                       v-bind:data="icpe_etablissements_risque"/>
            <PictoItem v-if="this.icpe_proches_risque!=null&&this.detail==null" v-bind:data="icpe_proches_risque"/>
            <PictoItem v-if="this.quartierprioritaire!=null&&this.detail==null" v-bind:data="quartierprioritaire"/>
            <PictoItem v-if="this.centrecommercial!=null&&this.detail==null" v-bind:data="centrecommercial"/>


          </v-card-text>

          <a v-if="detail!=null"  class="anchor" id="blocicpe"></a>

          <v-card-title v-if="detail!=null&&icpe_etablissements!=null && icpe_etablissements.length>0">Etablissement
            détenus classés ICPE ({{ icpe_etablissements.length }})
          </v-card-title>
          <v-card-text v-if="this.icpe_etablissements_risque!=null&&this.detail!=null">
            <PictoItem v-bind:data="icpe_etablissements_risque"/>

            <Icpe v-bind:listetabs="icpe_etablissements"></Icpe>
          </v-card-text>
          <v-card-title v-if="detail!=null&&icpe_proches!=null && icpe_proches.length>0">Etablissement
            proches classés ICPE ({{ icpe_proches.length }})
          </v-card-title>
          <v-card-text v-if="this.icpe_proches_risque!=null&&this.detail!=null">
            <PictoItem v-bind:data="icpe_proches_risque"/>
            <Icpe v-bind:listetabs="icpe_proches"></Icpe>
          </v-card-text>


          <a v-if="detail!=null"  class="anchor" id="bloccatnat"></a>

          <v-card-title v-if="detail!=null&&catnat_liste&& catnat_liste.length>0">Détail des arrétés Catastrophe
            Naturelle ({{ catnat_liste.length }})
          </v-card-title>
          <v-card-text v-if="this.catnat!=null&&this.detail!=null">
            <PictoItem v-bind:data="catnat"/>

            <v-data-table
                v-if="detail!=null&&catnat_liste&& catnat_liste.length>0"
                dense
                :headers="headers"
                :items="catnat_liste"
                item-key="id"
                class="elevation-1"

            >
            </v-data-table>
          </v-card-text>
          <a v-if="detail!=null"  class="anchor" id="bloclisterisques"></a>
          <v-card-title v-if="detail!=null&&risques_liste!=null && risques_liste.length>0">Détail risques
            ({{ risques_liste.length }})
          </v-card-title>
          <v-card-text v-if="this.risques!=null&&this.detail!=null">
            <PictoItem v-bind:data="risques"/>

            <v-simple-table v-if="detail!=null&&risques_liste&& risques_liste.length>0">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Risque
                  </th>

                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item,i) in risques_liste"
                    v-bind:key="i"
                >
                  <td>{{ item }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

        </v-card>


          <a v-if="detail!=null"  class="anchor" id="bloccentrecommercial"></a>

          <v-card-title v-if="detail!=null&&centrecommercial_liste&& centrecommercial_liste.length>0">Détail des commerces à la même adresse ({{ centrecommercial_liste.length }})
          </v-card-title>
          <v-card-text v-if="this.centrecommercial_liste!=null&&this.detail!=null">
            <PictoItem v-bind:data="centrecommercial"/>

            <v-data-table
                v-if="detail!=null&&centrecommercial_liste&& centrecommercial_liste.length>0"
                dense
                :headers="headers_centrecommercial"
                :items="centrecommercial_liste"
                item-key="id"
                class="elevation-1"

            >
                <template #item.siret="{ item }"><a @click="displaySelected(item.siret)">
                      <v-icon x-small v-if="item.siret!=''">mdi-open-in-new</v-icon>
                      {{ item.siret ? item.siret : "" }}</a></template>
            </v-data-table>
          </v-card-text>


      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.MINIMAL, .FAIBLE, .ible {
  background-color: #c8e6c9; 
}
.MOYEN, .yen {
  background-color: lightgoldenrodyellow;
}
.FORT, .rt {
  background-color: lightpink;
}
.TRES_FORT {
  background-color: #ff5f5f;
  font-weight: 400;
}

.MAXIMAL,  .tspot, .ximal{
  background-color: #ff5f5f;
  font-weight: 400;
}
</style>


<script>
import PictoItem from "@/components/layout/PictoItem.vue";
import Icpe from '@/components/etablissement/ipce';

export default {
  name: "Risque",
  props: ["detail"],
  components: {
    PictoItem, Icpe
  },
  data() {
    return {}
  },
  created() {

    this.risques_data = {
      "SECH_V5": {
        "display" : false,
        "icon": "mdi-water-off",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "orange", "orange darken-3", "red"]
      },
      "INOND_V5": {
        "display" : false,
        "icon": "mdi-swim",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "yellow darken-1", "orange", "orange darken-3", "red"]
      },
      "VENTMRH_V5": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "orange", "orange darken-3", "red"]
      },
      "VENTGPI_V5": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "orange", "orange darken-3", "red"]
      },
      "VENTMRC_V5": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "orange", "orange darken-3", "red"]
      },
      "GRELE_V5": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "SECH": {
        "display" : true,
        "icon": "mdi-water-off",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "ZUS": {
         "display" : true,
          "icon": "mdi-pistol ",
          "color": ["green lighten-2", "red"]
      },
      "QPV": {
         "display" : true,
          "icon": "mdi-home-group",
          "color": ["green lighten-2", "red"]
      },
      "INOND": {
        "display" : true,
        "icon": "mdi-swim",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "VENTMRH": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "VENTGPI": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "VENTMRI": {
        "display" : false,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "VENTMRC": {
        "display" : true,
        "icon": "mdi-weather-windy",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "GRELE": {
        "display" : true,
        "icon": "mdi-weather-snowy",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "MULTIDOM": {
        "display" : true,
        "icon": "mdi-island",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "IDBATI": {
        "display" : false,
        "icon": "home",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "PRECGEO": {
        "display" : false,
        "icon": "home",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "SURFSOL": {
        "display" : false,
        "icon": "home",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "ANCONSTR": {
        "display" : false,
        "icon": "home",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "MATTOIT": {
        "display" : false,
        "icon": "home",
        "color": ["grey lighten-2", "green lighten-1", "orange", "red", "purple"]
      },
      "SISM": {
         "display" : true,
        "icon": "mdi-waveform",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "orange", "orange darken-3", "red"]
      },
      "RADON": {
         "display" : true,
        "icon": "mdi-radioactive",
        "color": ["grey lighten-2", "grey lighten-1", "yellow", "red"]
      }
    }
  }
  ,
  computed: {

    headers_tests() {
      return [
        {
          text: "",
          align: "start",
          value: "icon",
          fixed: true,
          width: "10px",
          sortable: false,
        },
        {
          text: "Risque",
          value: "libelle",
          align: "start",
          fixed: true,
          width: "150px",
          sortable: false,
        },
        {
          text: "Valeur",
          value: "valeur",
          align: "start",
          fixed: true,
          width: "50px",
          sortable: false,
        },
        {
          text: "Libelle",
          value: "valeur_libelle",
          align: "start",
          fixed: true,
          width: "80px",
          sortable: false,
        },
        {
          text: "Code",
          value: "detail",
          align: "start",
          fixed: true,
          width: "50px",
          sortable: false,
        },
        {
          text: "Description",
          value: "detail_libelle",
          align: "start",
          fixed: true,
          width: "250px",
          sortable: false,
        },
        {
          text: "Précison Géolocalisation",
          value: "geo_type",
          align: "start",
          fixed: true,
          width: "100px",
          sortable: false,
        },
      ]
    },

    items_tests: function () {
      var geo_type = this.$store.getters.getbloc("technique", "donnees", "geo_type", null, "valeur")
      var geo_assoc = {
        "0_PntAdrBati_A": "Bâtiment",
        "1_PntAdrPlaque": "Plaque d'Adresse",
        "2_AdrInterpole": "Adresse Interpolée",
        "3_PntAdrAutres": "Adresse",
        "4_Voie_Advance": "Voie",
        "5_LieuDitHabit": "Lieu Dit",
        "6_ChefLieu": "Chef Lieu",
        "7_CodePostal": "Code Postal",
        "8_Ville": "Ville",
        "locality": "Ville",
        "municipality": "Municipalité",
        "street": "Voie",
        "housenumber": "Bâtiment",
      }
      if (geo_type!=null) {
        geo_type = geo_assoc[geo_type]
      }
      var array = []
      var items = this.$store.getters.getbloc("risque", "indicateurs", "georisk", null, "valeur")

      for(var i of items) {
        var item = {
            "icon": this.get_icon(i["risque"]),
            "libelle": i["libelle"],
            "valeur": i["valeur"] + "/" + i["max"],
            "valeur_libelle": i["valeur_libelle"]===undefined ? "" : i["valeur_libelle"] === i["valeur_libelle"].toUpperCase() ? i["valeur_libelle"].slice(2) : i["valeur_libelle"],
            "detail": i["detail"],
            "detail_libelle": i["detail_libelle"],
            "geo_type": (i["libelle"] === undefined ? "" : i["libelle"].includes("Vent") ? "Département" : geo_type),
            "class": (i["valeur_libelle"]===undefined ? "" : i["valeur_libelle"].slice(2)),
        }
        if (this.risques_data[i["risque"]]["display"]){
          array.push(item)
        }
      }

      var otherValeurLibelle = {
        3: {1: "MINIMAL", 2: "MOYEN", 3: "FORT"},
        5: {1: "MINIMAL", 2: "FAIBLE", 3: "MOYEN", 4: "FORT", 5: "MAXIMAL"},
      }
      items = this.$store.getters.getbloc("risque", "indicateurs", "radon", null, "valeur")
      if (items != null){
        for(i of items) {
          item = {
              "icon": this.get_icon(i["risque"]),
              "libelle": i["libelle"],
              "valeur": i["valeur"] + "/" + i["max"],
              "valeur_libelle": otherValeurLibelle[i["max"]][i["valeur"]],
              "class": otherValeurLibelle[i["max"]][i["valeur"]],
              "geo_type": geo_type,
          }
          array.push(item)
        }
      }
      items = this.$store.getters.getbloc("risque", "indicateurs", "sismique", null, "valeur")
      if (items != null){
        for(i of items) {
          item = {
              "icon": this.get_icon(i["risque"]),
              "libelle": i["libelle"],
              "valeur": i["valeur"] + "/" + i["max"],
              "valeur_libelle": otherValeurLibelle[i["max"]][i["valeur"]],
              "class": otherValeurLibelle[i["max"]][i["valeur"]],
              "geo_type": geo_type,
          }
          array.push(item)
        }
      }
      return array
    },

    headers_centrecommercial() {
           return [
        {
          text: "Siret",
          align: "start",
          sortable: false,
          value: "siret",
          fixed: true,
          width: "10px",
        },

        {
          text: "Nom",
          value: "denominationUniteLegale",
          align: "start",
          fixed: true,
          width: "100px",
        },
             {
          text: "Enseigne",
          value: "enseigne1Etablissement",
          align: "start",
          fixed: true,
          width: "100px",
        },
      ]
    },
    headers() {
      return [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "date",
          fixed: true,
          width: "10px",
        },

        {
          text: "Evènement",
          value: "evenement",
          align: "start",
          fixed: true,
          width: "100px",
        },
      ]
    },
    risque_icon: function () {
      return "mdi-weather-windy"
    },
    catnat_liste: function () {
      var listcat = this.$store.getters.getbloc("risque", "indicateurs", "catnat", null, "valeur")
      if (listcat!=null) {
        return listcat.map((item, index) => ({

          id: index,
          ...item
        }))
      } else {
        return null
      }
      },
    icpe_etablissements: function () {
      return this.$store.getters.getbloc("risque", "donnees", "liste_icpe_etablissements", null, "valeur")
    },
    icpe_etablissements_risque: function () {
      if (this.icpe_etablissements != null) {
        const result = this.icpe_etablissements.filter(etab => ['SH', 'SB'].includes(etab.seveso));
        var nbSeveso = result.length
        return {
          "id": "blocrisque",
          "tooltip": this.icpe_etablissements.length + " établissements classés icpe",
          "icon": "mdi-bomb",
          "color": nbSeveso > 0 ? "red" : "grey",
          "text": this.icpe_etablissements.length + " ICPE"
        }
      } else {
        return null
      }
    },
    icpe_proches: function () {
      return this.$store.getters.getbloc("risque", "donnees", "liste_icpe_proches", null, "valeur")
    },
    icpe_proches_risque: function () {
      if (this.icpe_proches != null) {
        const result = this.icpe_proches.filter(etab => etab.seveso == "S");
        var nbSeveso = result.length
        return {
          "id": "blocicpe",
          "tooltip": this.icpe_proches.length + "établissements",
          "icon": "mdi-bomb",
          "color": nbSeveso > 0 ? "red" : this.icpe_proches.length > 0  ? "blue" : "grey",
          "text": this.icpe_proches.length + " ICPE proches"
        }
      } else {
        return null
      }
    },

    catnat: function () {
      try {
        var data = this.catnat_liste
        if (data) {
          return {
            "id": "bloccatnat",
            "tooltip": data.length + " catnat",
            "icon": "mdi-map-marker-alert-outline",
            "color": data.length > 0 ? "blue" : "grey",
            "text": data.length + " catnat"
          }

        } else {
          return null
        }
      } catch (error) {
        console.error(error);
        return null
      }
    },
    risques_liste: function () {
      return this.$store.getters.getbloc("risque", "indicateurs", "risques", null, "valeur")
    },
    risques: function () {
      try {
        var data = this.risques_liste
        if (data) {
          return {
            "id": "bloclisterisques",
            "tooltip": data.length + " risques",
            "icon": "mdi-alarm-light-outline",
            "color": data.length > 0 ? "blue" : "grey",
            "text": data.length + " risques"
          }

        } else {
          return null
        }
      } catch (error) {
        console.error(error);
        return null
      }
    },
    radon: function () {
      try {
        var riskbrut = this.$store.getters.getbloc("risque", "indicateurs", "radon", null, "valeur")
        if (riskbrut) {
          var risk = riskbrut[0]
          return {
            "id": "blocrisque",
            "tooltip": risk.libelle,
            "icon": this.risques_data[risk.risque]["icon"],
            "color": this.risques_data[risk.risque]["color"][risk.valeur],
            "text": (this.detail != null ? risk.libelle + " : " : "") + risk.valeur + "/" + risk.max
          }
        }
        return null

      } catch (error) {
        console.error(error);
        return null
      }
    },
    seismes: function () {
      try {
        var riskbrut = this.$store.getters.getbloc("risque", "indicateurs", "sismique", null, "valeur")
        if (riskbrut) {
          var risk = riskbrut[0]
          return {
            "id": "blocrisque",
            "tooltip": risk.libelle,
            "icon": this.risques_data[risk.risque]["icon"],
            "color": this.risques_data[risk.risque]["color"][risk.valeur],
            "text": (this.detail != null ? risk.libelle + " : " : "") + risk.valeur + "/" + risk.max

          }
        }
        return null

      } catch (error) {
        console.error(error);
        return null
      }
    },
     quartierprioritaire: function () {
      try {
        var qp = this.$store.getters.getbloc("risque", "indicateurs", "quartiers_prioritaires", false, "valeur")
          return {
            "id": "blocrisque",
            "tooltip": (qp ? "Etablissement situé en Quartier prioritaire" : "Hors quartier prioritaire de la politique de la ville"),
            "icon": "mdi-home-group",
            "color": (qp ? "yellow" : "grey"),
            "text": (qp ? "Quartier prioritaire" : "Hors QPV")
          }
      } catch (error) {
        console.error(error);
        return null
      }
    },
    georisk: function () {
      try {
        var riskbrut = this.$store.getters.getbloc("risque", "indicateurs", "georisk", null, "valeur")
        if (riskbrut != null ) {
          var pictoData = riskbrut.map((risk) => {
             if (risk && risk.risque !=null && this.risques_data[risk.risque]["display"] ) {
                  return {
                    "id": "blocrisque",
                    "key" : risk.risque,
                    "tooltip": risk.libelle,
                    "icon": this.risques_data[risk.risque]["icon"],
                    "color": this.risques_data[risk.risque]["color"][risk.valeur],
                    "text": (this.detail != null ? risk.libelle + " : " : "") + risk.valeur + "/" + risk.max
                  }
                }
              }
          ).filter((risk)=> risk!=null);
          //pictoData = pictoData.filter((risk)=> risk!=null)

          return pictoData
        } else {
          return null
        }
      } catch (error) {
        console.error(error);
        return null
      }

    },
      centrecommercial_liste: function () {
      return this.$store.getters.getbloc("risque", "donnees", "suspicionCentreCommercial", null, "valeur")
    },
      centrecommercial: function () {
        try {
        var data = this.$store.getters.getbloc("risque", "donnees", "suspicionCentreCommercial", null, "valeur")
          if (data && data.length>0 ) {
            return {
              "id": "bloccentrecommercial",
              "tooltip": data.length + " commerces à la même adresse",
              "icon": "mdi-cart-outline",
              "color": data.length > 30 ? "red" : data.length >= 10 ? "orange" : data.length > 0 ? "blue" : "grey",
              "text": data.length + " commerces"
            }

        } else {
           return null
        }
      } catch (error) {
        console.error(error);
        return null
      }

    },

  }
  ,

  methods: {
     displaySelected(siret) {
        this.$store.dispatch('getEtablissement',siret)
    },
    condition() {
      return this.$store.getters.condition("risque", "indicateurs")
    },
    get_icon(risque) {
      return this.risques_data[risque]['icon']
    },
    containsObject(obj, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i]["msg"] === obj["msg"])
          return true;
      }
      return false;
    }
  }
  ,
}
;
</script>
